export default "__VITE_ASSET__C83r35_O__"